import type { SxProps, Theme } from "@mui/material";
import type { useCustomColors } from "../hooks/useCustomColors";

type Colors = ReturnType<typeof useCustomColors>;

/** Metallic gold with a slow shine sweep. Monetary values only. */
export const goldShineSx = (colors: Colors): SxProps<Theme> => ({
  display: "inline-block",
  background: colors.gradient.goldShine,
  backgroundSize: "300% 100%",
  backgroundClip: "text",
  WebkitBackgroundClip: "text",
  color: "transparent",
  WebkitTextFillColor: "transparent",
  textShadow:
    "0 0 8px rgba(212, 175, 55, 0.20), 0 0 18px rgba(212, 175, 55, 0.10)",
  animation: "goldSweep 3.2s ease-in-out infinite",
  "@keyframes goldSweep": {
    "0%": { backgroundPosition: "180% 0" },
    "55%, 100%": { backgroundPosition: "-40% 0" },
  },
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none",
    background: "none",
    color: colors.accent.gold,
    WebkitTextFillColor: colors.accent.gold,
  },
});
